import { render, staticRenderFns } from "./duibaRedirect.vue?vue&type=template&id=804b687a&scoped=true&"
import script from "./duibaRedirect.vue?vue&type=script&lang=ts&"
export * from "./duibaRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b687a",
  null
  
)

export default component.exports